import {RangeEnum} from "../enums/range";
import { addDays, eachWeekendOfInterval, endOfDay, endOfMonth, endOfWeek, startOfDay } from 'date-fns';

export const RANGES = {
	[RangeEnum.Today]: () => ({
		name: 'Today',
		value: RangeEnum.Today,
		startDate: startOfDay(new Date()).toUTCString(),
		endDate: endOfDay(new Date()).toUTCString()
	}),
	[RangeEnum.Tomorrow]: () => ({
		name: 'Tomorrow',
		value: RangeEnum.Tomorrow,
		startDate: startOfDay(addDays(new Date(), 1)).toUTCString(),
		endDate: endOfDay(addDays(new Date(), 1)).toUTCString()
	}),
	[RangeEnum.ThisWeekend]: () => {
		const dateList = eachWeekendOfInterval({
			start: new Date(),
			end: endOfWeek(new Date(), {weekStartsOn: 1})
		});

		return {
			name: 'This Weekend',
			value: RangeEnum.ThisWeekend,
			startDate: startOfDay(new Date(dateList[0])).toUTCString(),
			endDate: endOfDay(new Date(dateList[1])).toUTCString()
		}
	},
	[RangeEnum.ThisWeek]: () => ({
		name: 'This Week',
		value: RangeEnum.ThisWeek,
		startDate: startOfDay(new Date()).toUTCString(),
		endDate: endOfWeek(new Date(), {weekStartsOn: 1}).toUTCString()
	}),
	[RangeEnum.ThisMonth]: () => ({
		name: 'This Month',
		value: RangeEnum.ThisMonth,
		startDate: new Date().toUTCString(),
		endDate: endOfMonth(new Date()).toUTCString()
	}),
	[RangeEnum.All]: () => ({
		name: 'All',
		value: RangeEnum.All,
		startDate: startOfDay(new Date()).toUTCString(),
		endDate: null
	}),
	[RangeEnum.Custom]: (periodFrom = null, periodTo = null) => ({
			name: 'Custom',
			value: RangeEnum.Custom,
			startDate: periodFrom ? startOfDay(new Date(periodFrom)).toUTCString() : startOfDay(new Date()).toUTCString(),
			endDate: periodTo ? endOfDay(new Date(periodTo)).toUTCString() : null
	}),
}
